import { defineComponent as e } from "vue";
const n = /* @__PURE__ */ e({
  __name: "charger-box",
  props: {
    isIncluded: { type: Boolean }
  },
  setup(o) {
    return { __sfc: !0 };
  }
});
export {
  n as default
};
